
import { useState, useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSubscriptionsData } from './useSubscriptionsData';

export const useSubscriptionsAdmin = () => {
  const [searchParams] = useSearchParams();
  const [searchTerm, setSearchTerm] = useState('');
  const [shouldRefresh, setShouldRefresh] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  // Добавляем состояние для отслеживания видимости панели предстоящих платежей
  const [showUpcomingPayments, setShowUpcomingPayments] = useState<boolean>(() => {
    // Получаем сохраненное значение из localStorage или показываем панель по умолчанию
    const saved = localStorage.getItem('admin-show-upcoming-payments');
    return saved !== null ? saved === 'true' : true;
  });

  const {
    subscriptions: allSubscriptions,
    loading,
    error,
    statusFilter,
    selectedSubscription,
    showDetailsDialog,
    actionLoading,
    isEditMode,
    subscriptionsCount,
    fetchData,
    handleStatusChange,
    handleClearFilter,
    handleViewSubscription,
    handleCloseDialog,
    handleStatusUpdate,
    handleDeleteSubscription,
    handleEditSubscription,
    handleCloseEditMode
  } = useSubscriptionsData();

  // Обработчик обновления данных с предотвращением мерцания
  const optimizedFetchData = useCallback(() => {
    setShouldRefresh(true);
  }, []);

  // Функция для переключения видимости панели предстоящих платежей
  const toggleUpcomingPayments = useCallback(() => {
    const newValue = !showUpcomingPayments;
    setShowUpcomingPayments(newValue);
    // Сохраняем значение в localStorage
    localStorage.setItem('admin-show-upcoming-payments', String(newValue));
  }, [showUpcomingPayments]);

  useEffect(() => {
    if (shouldRefresh) {
      fetchData();
      setShouldRefresh(false);
    }
  }, [shouldRefresh, fetchData]);

  // Фильтрация подписок по поисковому запросу
  const subscriptions = allSubscriptions.filter(sub => {
    if (!searchTerm) return true;

    // Преобразуем строку поиска в нижний регистр
    const term = searchTerm.toLowerCase();
    
    // Ищем по номеру аренды или имени курьера
    const rentalNumber = sub.rentals?.human_number?.toLowerCase() || '';
    const courierName = sub.rentals?.courier?.name?.toLowerCase() || '';
    
    return rentalNumber.includes(term) || courierName.includes(term);
  });

  // Обработчик поиска
  const handleSearch = (term: string) => {
    setSearchTerm(term);
  };

  // Эффект для обработки параметров URL
  useEffect(() => {
    if (!isInitialized) {
      // Отмечаем, что инициализация выполнена
      setIsInitialized(true);
      
      // Проверяем, есть ли параметр id в URL
      const subscriptionId = searchParams.get('id');
      if (subscriptionId) {
        console.log('Найден ID подписки в URL:', subscriptionId);
        handleViewSubscription(subscriptionId);
      }
    }
  }, [searchParams, isInitialized, handleViewSubscription]);

  return {
    subscriptions,
    loading,
    error,
    statusFilter,
    selectedSubscription,
    showDetailsDialog,
    actionLoading,
    isEditMode,
    subscriptionsCount,
    showUpcomingPayments,
    fetchData: optimizedFetchData,
    handleStatusChange,
    handleClearFilter,
    handleViewSubscription,
    handleCloseDialog,
    handleStatusUpdate,
    handleDeleteSubscription,
    handleSearch,
    handleEditSubscription,
    handleCloseEditMode,
    toggleUpcomingPayments
  };
};
